import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 10px 10px 0 10px;
  background-color: ${({ theme }) => theme.colors.cardBackground};
`;
